import { render, staticRenderFns } from "./CloudPay.vue?vue&type=template&id=381facfd&scoped=true"
import script from "./CloudPay.vue?vue&type=script&lang=js"
export * from "./CloudPay.vue?vue&type=script&lang=js"
import style0 from "./CloudPay.vue?vue&type=style&index=0&id=381facfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381facfd",
  null
  
)

export default component.exports